<div class="sm:hidden">
    <app-select [id]="'select-tab' + id" [(ngModel)]="selectedTab" label=" " [options]="tabAsOptions" id="select-tab" (ngModelChange)="onSelectedTabDropdownChangeEvent()"></app-select>
</div>
<div class="hidden sm:block border-b border-gray-200 mb-8">
    <nav role="tablist" class="-mb-px flex space-x-8 max-w-full overflow-auto scrollbar" aria-label="Tabs">
        <a *ngFor="let tab of tabs"
            class="whitespace-nowrap border-b-2 border-transparent px-1 py-3 body-large-bold hover:text-black cursor-pointer"
            (click)="onSelectTabClickEvent(tab)"
            [ngClass]="selectedTab === tab.id ? 'text-black border-b-brand-orange' : 'text-gray-500'"
            [id]="'tab-' + id + '-' + tab.id"
            role="tab"
            [attr.aria-selected]="selectedTab === tab.id"
            [attr.tabindex]="selectedTab === tab.id ? 0 : -1"
        >
            {{ tab.label }}
        </a>
    </nav>
</div>
